import { memo } from "react";

import { BentoBoxCard } from "@react/sections/BentoBox/BentoBoxCard";
import { type BentoBoxCardProps } from "@root/tablescape/state/bentoBox";
import { type TTailwindString, tw } from "classnames";

export const styles = {
  base: tw(
    "grid",
    "grid-cols-1",
    "md:grid-cols-[1fr_1fr]" as TTailwindString,
    "mg:grid-cols-[2fr_3fr]" as TTailwindString,
    "grid-rows-[432px_476px_349px_432px]" as TTailwindString,
    "md:grid-rows-[419px_324px_295px]" as TTailwindString,
    "mg:grid-rows-[466px_320px]" as TTailwindString,
    "lg:grid-rows-[575px_388px]" as TTailwindString,
    "xl:grid-rows-[653px_440px]" as TTailwindString,
    "gap-4",
    "lg:gap-6"
  ),
  nestedGrid: tw(
    "flex",
    "flex-col",
    "md:grid",
    "grid-cols-1",
    "mg:grid-cols-[1fr_1fr_1fr]" as TTailwindString,
    "grid-rows-[repeat(3,1fr)]" as TTailwindString,
    "mg:grid-rows-[194px_256px]" as TTailwindString,
    "lg:grid-rows-[240px_311px]" as TTailwindString,
    "xl:grid-rows-[280px_349px]" as TTailwindString,
    "gap-4",
    "lg:gap-6"
  ),
  card4: tw("md:col-span-2", "mg:hidden"),
  nestedCard4: tw("col-span-3", "hidden", "mg:flex"),
  card5: tw("md:col-span-2"),
};

type Props = {
  cards: BentoBoxCardProps[];
  handleModalOpen: (index: number) => void;
};

const BentoBoxCardsLayoutBBase = ({ cards, handleModalOpen }: Props) => {
  return (
    <div className={styles.base}>
      {cards[0] && (
        <BentoBoxCard
          {...cards[0]}
          {...(cards[0].modalContent?.showModal && {
            handleCtaClick: () => handleModalOpen(0),
          })}
          position={1}
        />
      )}
      <div className={styles.nestedGrid}>
        {cards[1] && (
          <BentoBoxCard
            {...cards[1]}
            {...(cards[1].modalContent?.showModal && {
              handleCtaClick: () => handleModalOpen(1),
            })}
            position={2}
          />
        )}
        {cards[2] && (
          <BentoBoxCard
            {...cards[2]}
            {...(cards[2].modalContent?.showModal && {
              handleCtaClick: () => handleModalOpen(2),
            })}
            position={3}
          />
        )}
        {cards[3] && (
          <BentoBoxCard
            {...cards[3]}
            {...(cards[3].modalContent?.showModal && {
              handleCtaClick: () => handleModalOpen(3),
            })}
            position={4}
          />
        )}
        {cards[4] && (
          <BentoBoxCard
            {...cards[4]}
            className={styles.nestedCard4}
            {...(cards[4].modalContent?.showModal && {
              handleCtaClick: () => handleModalOpen(4),
            })}
            position={5}
          />
        )}
      </div>
      {cards[4] && (
        <BentoBoxCard
          {...cards[4]}
          className={styles.card4}
          {...(cards[4].modalContent?.showModal && {
            handleCtaClick: () => handleModalOpen(4),
          })}
          position={5}
        />
      )}
      {cards[5] && (
        <BentoBoxCard
          {...cards[5]}
          className={styles.card5}
          {...(cards[5].modalContent?.showModal && {
            handleCtaClick: () => handleModalOpen(5),
          })}
          position={6}
        />
      )}
    </div>
  );
};

export const BentoBoxCardsLayoutB = memo(BentoBoxCardsLayoutBBase);
